import { oz } from '@weft/utils';
import { AGGREGATION_WITH_FIELD_OPERATORS } from '../aggregation-operator-schema';
import { BaseAggregationMethodSchema } from '../base-aggregation-method-schema';

export const AggregationMaxMethodSchema = BaseAggregationMethodSchema.extend({
  field: oz.string().nonempty(),
  operator: oz.literal(AGGREGATION_WITH_FIELD_OPERATORS.Max),
}).openapi('AggregationMaxMethod');
  
export type AggregationMaxFieldMethod = oz.infer<typeof AggregationMaxMethodSchema>;
